import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { bankDetailActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const BankDetails = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
  const bankDetails = useSelector((state) => state.bankDetails);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "bankname", headerName: "Bank Name", width: 150 },
    { field: "accountname", headerName: "Account Name", width: 150 },
    { field: "bsb", headerName: "BSB", width: 150 },
    { field: "accountnumber", headerName: "Account Number", width: 150 },
    { field: "status", headerName: "Status", width: 150 },
  ];

  const recordIdentifier = "bankname";

  useEffect(() => {
    dispatch(bankDetailActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
      {bankDetails && (
        <DataTable
          loading={bankDetails?.loading}
          rows={bankDetails?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="bankDetailActions"
          search ={searchQuery}
        />
      )}
    </Box>
  );
};

export default BankDetails;
